<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsImport-settlementData',
  components: { PageTable },
}
</script>
